/**
 * 商品概况模块接口列表
 */

import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const entergoods = {
  // GET/tenantgoodstype/query PC----根据tenantId查询信息-----ygt
  tenantgoodstype() {
    return axios.get(`${base.baseURL}tenantgoodstype/query`)
  },
  // POST/goods/goods添加入库根据商品编码查找
  goodsGoods(params) {
    return axios.post(`${base.baseURL}goods/goods`,params)
  },
   // POST/goodsputrecord/update PC---根据商品编号修改入库信息记录---ygt
   updatedSputre(params) {
    return axios.post(`${base.baseURL}goodsputrecord/update`, params)
  },
}
export default entergoods;



// WEBPACK FOOTER //
// ./src/network/entergoods.js